<template>
    <div class="form-field form-code" :rel="name" v-bind:class="{'form-required': requiredForm}">
        <div class="form-label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">

                <div class="editor-frame" v-bind:class="{'fullscreen': fullscreen, 'layout-code': view == 'layout-code', 'layout-design': view == 'layout-design'}" v-if="internalValue">
                    <div class="editor-frame-content">

                        <div v-if="isModalImageVisible" class="editor-modal">
                            <div class="editor-modal-overlay" @click="closeModal()"></div>
                            <article class="editor-modal-content">
                                <header>
                                    <figure><i class="icon icon-icon_picture"></i></figure>
                                    <div>
                                        <h1>Image</h1>
                                    </div>
                                    <div class="spacer"></div>
                                    <div>
                                        <button @click="closeModal()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                                        <button @click="validateModal()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                                    </div>
                                </header>
                                <div>

                                    <tabs :options="{ useUrlFragment: false }">
                                        <tab name="Url">

                                            <form-text label="URL" v-model="targetValue"></form-text>

                                        </tab>
                                        <tab name="Téléchargement">

                                            <form-gallery label="" v-model="medias" :callback="selectImage"></form-gallery>

                                        </tab>
                                    </tabs>

                                </div>
                            </article>
                        </div>

                        <div v-if="isModalUrlVisible" class="editor-modal">
                            <div class="editor-modal-overlay" @click="closeModal()"></div>
                            <article class="editor-modal-content">
                                <header>
                                    <figure><i class="icon icon-icon_earth"></i></figure>
                                    <div>
                                        <h1>Link</h1>
                                    </div>
                                    <div class="spacer"></div>
                                    <div>
                                        <button @click="closeModal()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                                        <button @click="validateModal()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                                    </div>
                                </header>
                                <div>

                                    <form-text label="URL" v-model="targetValue"></form-text>

                                </div>
                            </article>
                        </div>

                        <div class="options">
                            <languages :locales="locales" v-model="locale" :localesLoaded="true" :all="false"></languages>

                            <button @click="codeView()" class="view" v-bind:class="{'active':view=='layout-code'}">
                                <span class="icon icon-view-code"></span>
                            </button>

                            <button @click="designView()" class="view" v-bind:class="{'active':view=='layout-design'}">
                                <span class="icon icon-view-design"></span>
                            </button>

                            <button @click="splitView()" class="view" v-bind:class="{'active':view=='layout-split'}">
                                <span class="icon icon-view-split"></span>
                            </button>

                            <button @click="fullScreen()" class="close">
                                <span class="icon icon-icon_expand" v-if="!fullscreen"></span>
                                <span class="icon icon-icon_close" v-if="fullscreen"></span>
                            </button>
                        </div>
                        <div class="editor-view" v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                            <div class="editor">
                                <prism-editor v-model="internalValue[client.id][variable]" :language="language"></prism-editor>
                            </div>
                            <div class="preview">
                                <iframe frameborder="0" allowfullscreen="true" allowtransparency="true" :id="id+'_'+client.id"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
                <i :class="langClass" v-if="lang"><img :src="'/src/assets/flags/'+lang+'.svg'"></i>

            </div>
        </div>
    </div>
</template>

<script>

    import Modal from './EditorModal.vue'

    export default {
        name: 'FormCodeTextarea',
        components: {
            Modal
        },
        props: ['value','label','name','placeholder','lang','required','language','callback','medias'],
        data: function () {
            return {
                isModalImageVisible: false,
                isModalUrlVisible: false,
                animate: null,
                debounce: null,
                debounceWysywyg: null,
                internalValue: '',
                langClass: '',
                fullscreen: false,
                id: null,
                locale: null,
                locales: null,
                variable: 'template',
                callbackModal: null,
                targetValue: null,
                view: "layout-design"
            }
        },
        created: function() {
            this.locale = this.lang ? this.lang : this.$store.state.scope.locales[0].id,
            this.locales = this.$store.state.scope.locales

            this.internalValue = this.value;
            this.langClass = this.lang?"flag lang-"+this.lang:"";
            this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
            this.onChange = this.callback ? true : false;

            let r = Math.random().toString(36).substring(7);
            this.id = r;

            this.preview();

            window.getOffset = function( el ) {
                var _x = 0;
                var _y = 0;
                while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
                    _x += el.offsetLeft - el.scrollLeft;
                    _y += el.offsetTop - el.scrollTop;
                    el = el.offsetParent;
                }
                return { top: _y, left: _x };
            }


            var self = this;

            window.weeboxEditorEditLink = function(target, lang)
            {
                var url = target.getAttribute('href');

                self.editorChangeUrl(url, function(value){
                    target.setAttribute('href', value);

                    var markup = target.closest('html').outerHTML;
                    self.internalValue[lang][self.variable] = markup
                });
            }


            window.weeboxEditorEditImage = function(target, lang)
            {
                self.editorChangeImage(target.getAttribute("src"), function(value){
                    target.setAttribute('src', value);

                    var markup = target.closest('html').outerHTML;
                    self.internalValue[lang][self.variable] = markup
                });
            }


        },
        methods: {
            preview: function(){

                let self = this

                clearInterval(self.debounce)
                self.debounce = setTimeout(function(){

                    for(let client of self.locales){

                        let loopId = self.id + "_" + client.id;

                        if( document.getElementById(loopId) && document.getElementById(loopId).contentWindow ){
                            var x = document.getElementById(loopId).contentWindow.document;
                            x.open();
                            x.write( self.internalValue[client.id][self.variable] );
                            x.close();

                            // Delete node
                            var weeboxEditLinks = x.querySelectorAll("[rel='weebox-edit-link']");
                            for(let elm of weeboxEditLinks) {
                                elm.parentNode.removeChild(elm);
                            }
                            // ENd

                            // CREATE OPTIONS
                            var weeboxEditLink = document.createElement('div');
                            x.body.appendChild(weeboxEditLink);
                            weeboxEditLink.setAttribute('rel', 'weebox-edit-link');
                            // END


                            var elements = x.querySelectorAll("multiline,singleline");
                            for(let elm of elements) {
                                elm.setAttribute("contenteditable", "true");
                            }


                            var css = x.querySelectorAll("[id='weebox-edit-css']");
                            for(let elm of css) {
                                elm.parentNode.removeChild(elm);
                            }

                            var css = document.createElement('style');
                            css.setAttribute('id', 'weebox-edit-css');
                            x.head.appendChild(css);
                            css.innerHTML = "[rel='weebox-edit-link']{"+
                                "   position:absolute;"+
                                "   top:0;left:50%;"+
                                "   background:white;"+
                                "   transform:translateX(-50%);"+
                                "   font-size:11px;"+
                                "   border-radius:2px;"+
                                "   box-shadow:0px 0px 10px rgba(0,0,0,0.5);"+
                                "   height:40px;"+
                                "   z-index:1000;"+
                                "   white-space:nowrap;"+
                                "   display:flex;"+
                                "   align-items:center;"+
                                "   transition: opacity 250ms ease-in-out;"+
                                "   opacity:0;"+
                                "   }";

                            css.innerHTML += "[rel='weebox-edit-link']:after{"+
                                "   content:'';"+
                                "   position:absolute;"+
                                "   left:calc(50% - 8px);"+
                                "   top:calc(100% - 10px);"+
                                "   transform:rotate(45deg);"+
                                "   width:16px;"+
                                "   height:16px;"+
                                "   background:#fff;"+
                                "   }";

                            css.innerHTML += "[rel='weebox-edit-link'] > div{"+
                                "   line-height:40px;"+
                                "   text-transform:uppercase;"+
                                "   padding:0 20px;"+
                                "   cursor:pointer;"+
                                "   position: relative;"+
                                "   border-radius:2px;"+
                                "   z-index:10;"+
                                "   }";

                            css.innerHTML += "[rel='weebox-edit-link'] > div:after{"+
                                "   content:'';"+
                                "   position:absolute;"+
                                "   right:0;"+
                                "   top:50%;"+
                                "   transform:translateY(-50%);"+
                                "   width:1px;"+
                                "   height:10px;"+
                                "   background:#aaa;"+
                                "   }";

                            css.innerHTML += "[rel='weebox-edit-link'] > div:last-child:after{"+
                                "   display:none;"+
                                "   }";

                            css.innerHTML += "[rel='weebox-edit-link'] > div:hover{"+
                                "   background: #eee;"+
                                "   }";

                            // Loop over the "<a>"
                            var elements = x.querySelectorAll("a");
                            for (var i= 0; i < elements.length; i++) {

                                // Cancel click on <a>
                                elements[i].addEventListener("click", function(e){
                                    e.preventDefault();
                                    e.stopPropagation();
                                    return false;
                                }, false);

                                elements[i].addEventListener("mouseover", function(e){

                                    var eventTarget = e.target;
                                    var position = window.getOffset(eventTarget);

                                    eventTarget.style.outline = "2px solid red";

                                    var elm = eventTarget.closest('body').querySelectorAll("[rel='weebox-edit-link']")[0];
                                    console.log("a mouseover");
                                    clearInterval(self.animate)
                                    elm.style.top = eventTarget.closest('body').scrollTop + position.top - 40 + "px";
                                    elm.style.left = position.left + eventTarget.offsetWidth/2 + "px";
                                    elm.style.visibility = "visible";
                                    elm.style.opacity = "1";
                                    elm.innerHTML = "<div rel='weebox-edit-link-action'><i class='icon icon-icon_earth'></i> Editer le lien</div>";

                                    elm.addEventListener("mouseover", function(e){
                                        clearInterval(self.animate);
                                        elm.style.opacity = "1";
                                        elm.style.visibility = "visible";
                                    });
                                    elm.addEventListener("mouseout", function(e){
                                        clearInterval(self.animate)
                                        elm.style.opacity = "0";
                                        self.animate = setTimeout(function(){ elm.style.visibility = "hidden"; }, 250);
                                    });

                                    elm.querySelectorAll("[rel='weebox-edit-link-action']")[0].addEventListener("click", function(e){
                                        e.preventDefault(); e.stopPropagation();

                                        window.weeboxEditorEditLink(eventTarget, client.id);

                                        return false;
                                    }, false);

                                });

                                elements[i].addEventListener("mouseout", function(e){

                                    console.log("a mouseout")

                                    var elm = e.target.closest('body').querySelectorAll("[rel='weebox-edit-link']")[0];

                                    e.target.style.outline = "0px";

                                    clearInterval(self.animate);
                                    elm.style.opacity = "1";
                                    self.animate = setTimeout(function(){ elm.style.visibility = "hidden"; }, 250);
                                    //e.target.querySelectorAll("[rel='weebox-edit']")[0].style.visibility = "hidden";

                                });

                            }

                            var images = x.querySelectorAll("img");
                            for (var i= 0; i < images.length; i++) {
                                images[i].addEventListener("click", function(e){
                                    e.preventDefault();
                                    e.stopPropagation();

                                    self.editorChangeImage(e.target.getAttribute("src"), function(value){
                                        e.target.setAttribute('src', value)

                                        var markup = e.target.closest('html').outerHTML;
                                        self.internalValue[client.id][self.variable] = markup
                                    });

                                    return false;
                                }, false);

                                images[i].addEventListener("mouseover", function(e){
                                    e.preventDefault();
                                    e.stopPropagation();

                                    var eventTarget = e.target;
                                    eventTarget.style.position = "relative";
                                    var position = window.getOffset(eventTarget);

                                    eventTarget.style.outline = "2px solid red";

                                    var elm = eventTarget.closest('body').querySelectorAll("[rel='weebox-edit-link']")[0];
                                    console.log("img mouseover");
                                    clearInterval(self.animate)
                                    elm.style.top = eventTarget.closest('body').scrollTop + position.top - 20 + "px";
                                    elm.style.left = position.left + eventTarget.offsetWidth/2 + "px";
                                    elm.style.visibility = "visible";
                                    elm.style.opacity = "1";
                                    elm.innerHTML = "<div rel='weebox-edit-link-action-1'><i class='icon icon-icon_earth'></i> Modifier l'image</div>";

                                    console.log("parent", eventTarget.parentNode.nodeName, eventTarget.parentNode.parentNode.nodeName)

                                    if( eventTarget.parentNode.nodeName == "A" || eventTarget.parentNode.parentNode.nodeName == "A" )
                                    {
                                        elm.innerHTML += "<div rel='weebox-edit-link-action-2'><i class='icon icon-icon_earth'></i> Editer le lien</div>";
                                    }

                                    elm.addEventListener("mouseover", function(e){
                                        clearInterval(self.animate);
                                        elm.style.opacity = "1";
                                        elm.style.visibility = "visible";
                                    });
                                    elm.addEventListener("mouseout", function(e){
                                        clearInterval(self.animate)
                                        elm.style.opacity = "0";
                                        self.animate = setTimeout(function(){ elm.style.visibility = "hidden"; }, 250);
                                    });

                                    elm.querySelectorAll("[rel='weebox-edit-link-action-1']")[0].addEventListener("click", function(e){
                                        e.preventDefault(); e.stopPropagation();

                                        window.weeboxEditorEditImage(eventTarget, client.id);

                                        return false;
                                    }, false);

                                    elm.querySelectorAll("[rel='weebox-edit-link-action-2']")[0].addEventListener("click", function(e){
                                        e.preventDefault(); e.stopPropagation();

                                        if( eventTarget.parentNode.nodeName == "A" )
                                        {
                                            var linkElm = eventTarget.parentNode;
                                        }

                                        if( eventTarget.parentNode.parentNode.nodeName == "A" )
                                        {
                                            var linkElm = eventTarget.parentNode.parentNode

                                        }

                                        window.weeboxEditorEditLink(linkElm, client.id);

                                        return false;
                                    }, false);


                                    return false;
                                }, false);

                                images[i].addEventListener("mouseout", function(e){
                                    e.preventDefault();
                                    e.stopPropagation();

                                    console.log("img mouseout");

                                    var elm = e.target.closest('body').querySelectorAll("[rel='weebox-edit-link']")[0];

                                    e.target.style.outline = "0px";

                                    clearInterval(self.animate);
                                    elm.style.opacity = "1";
                                    self.animate = setTimeout(function(){ elm.style.visibility = "hidden"; }, 250);

                                    return false;
                                }, false);
                            }

                            var editable = x.querySelectorAll("[contenteditable]");
                            for (var i= 0; i < editable.length; i++) {
                                editable[i].addEventListener("input", function(e){
                                    clearInterval(self.debounceWysywyg)
                                    self.debounceWysywyg = setTimeout(function(){

                                        var markup = e.target.closest('html').outerHTML;
                                        self.internalValue[client.id][self.variable] = markup

                                    }, 1000);
                                    return false;
                                });
                            }
                        }

                    }

                }, 2000)


            },
            fullScreen: function(){
                this.fullscreen = !this.fullscreen;
            },
            closeModal() {
                this.isModalImageVisible = false;
                this.isModalUrlVisible = false;
            },
            selectImage(value) {
                this.targetValue = value;
                this.validateModal();
            },
            validateModal() {
                this.callbackModal( this.targetValue );
                this.closeModal();
            },
            editorChangeImage(value, callback) {
                this.targetValue = value;
                this.isModalImageVisible = true;
                this.callbackModal = callback;
            },
            editorChangeUrl(value, callback) {
                this.targetValue = value;
                this.isModalUrlVisible = true;
                this.callbackModal = callback;
            },
            codeView: function(){
                this.view = "layout-code";
            },
            designView: function(){
                this.view = "layout-design";
            },
            splitView: function(){
                this.view = "layout-split";
            }
        },
        watch: {
            'value': {
                handler: function (newVal, oldVal) {
                    if( newVal != oldVal ){
                        this.internalValue = newVal
                        this.preview();
                    }
                },
                deep: true
            },
            'medias': {
                handler: function (newVal, oldVal) {
                    if( newVal != oldVal ){
                        this.$emit('updateEvent', this.medias);
                    }
                },
                deep: true
            },
            'internalValue': {
                handler: function (newVal, oldVal) {
                    console.log(newVal, oldVal)
                    //if( newVal != oldVal ) {
                        this.preview();
                        this.$emit('input', this.internalValue);
                        if (this.onChange) {
                            this.callback(this.internalValue)
                        }
                    //}
                },
                deep: true
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Editor.vue